import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

// `null` when unconfigured (e.g. local dev of the public landing page, or a
// build without Supabase env) so importing this never crashes page load —
// createClient() throws on an undefined URL. The public forms use Web3Forms and
// don't need Supabase; only the admin dashboard/auth do, and those guard on null.
export const supabase = (url && key)
  ? createClient(url, key, {
      auth: { persistSession: true, autoRefreshToken: true },
    })
  : null;
